import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { useNavigate, useParams } from "react-router-dom";
import { SharedInterfaceCardTransactions } from "../../home/transactions/cards/sharedInterface";
import { TransactionsSidePanel } from "../../home/transactions/sidePanel/SidePanel";
import { PublicTransactionsPropsType } from "../../home/transactions/transactionsAPI";
import {
  transactionsOfADepartmentListAsync,
  authorizationsOfADepartmentListAsync,
  sendSmsForDepartementAsync,
  getLastReminderDateForDepartmentAsync,
  sendSmsReplaceInvalidForDepartmentAsync,
  getSupportingDocumentForDepartment,
  selectTransactionsListStatus,
  selectAuthorizationsListStatus,
} from "../../home/transactions/transactionsSlice";

export const TransactionsCards = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const department = useAppSelector(selectCurrentDepartment);
  const transactionsOfADepartmentListStatus = useAppSelector(
    selectTransactionsListStatus,
  );
  const authorizationsOfADepartmentListStatus = useAppSelector(
    selectAuthorizationsListStatus,
  );

  useEffect(() => {
    if (department && transactionsOfADepartmentListStatus === "idle") {
      void dispatch(transactionsOfADepartmentListAsync(department.uuid));
    }
  }, [department, dispatch, transactionsOfADepartmentListStatus]);

  useEffect(() => {
    if (department && authorizationsOfADepartmentListStatus === "idle") {
      void dispatch(authorizationsOfADepartmentListAsync(department.uuid));
    }
  }, [department, dispatch, authorizationsOfADepartmentListStatus]);

  const sidePanelAction = useCallback(
    (props: Partial<PublicTransactionsPropsType>) => {
      navigate(`/departments/transactions/cards/${props.uuid}`);
    },
    [navigate],
  );

  const getLastReminderDateAction = useCallback(
    (transactionUuid: string) => {
      void dispatch(
        getLastReminderDateForDepartmentAsync({ transaction: transactionUuid }),
      );
    },
    [dispatch],
  );

  const sendSmsAction = useCallback(
    (props: {
      driverPhone: string;
      driverName: string;
      transactionUuid: string;
    }) => {
      void dispatch(sendSmsForDepartementAsync(props));
    },
    [dispatch],
  );

  const sendSmsReplaceInvalidAction = useCallback(
    (props: {
      driverPhone: string;
      driverName: string;
      transactionUuid: string;
    }) => {
      void dispatch(sendSmsReplaceInvalidForDepartmentAsync(props));
    },
    [dispatch],
  );

  const getSupportingDocumentAction = useCallback(
    (supportingDocumentUuid: string) => {
      void dispatch(getSupportingDocumentForDepartment(supportingDocumentUuid));
    },
    [dispatch],
  );

  if (params.tab !== "cards") {
    return;
  }

  return (
    <SharedInterfaceCardTransactions
      sidePanelAction={sidePanelAction}
      sidePanel={
        <TransactionsSidePanel
          sendSmsReplaceInvalidAction={sendSmsReplaceInvalidAction}
          getSupportingDocumentAction={getSupportingDocumentAction}
          getLastReminderDateAction={getLastReminderDateAction}
          sendSmsAction={sendSmsAction}
        />
      }
    />
  );
};
